class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    if (this.mainDetailsToggle.getAttribute("data-megamenu-type") === "hover") {
      this.mainDetailsToggle.addEventListener(
        "mouseenter",
        this.onHoverDetails.bind(this)
      );
      this.mainDetailsToggle.addEventListener(
        "mouseleave",
        this.onMouseLeaveDetails.bind(this)
      );
    } else {
      this.mainDetailsToggle.addEventListener(
        "click",
        this.onClickDetails.bind(this)
      );
    }
    this.megamenuLinks = [
      ...this.querySelectorAll(".tabbed-mega-menu > li > .mega-menu__link"),
    ];
    this.megamenuLinks.forEach((item) => {
      item.addEventListener(
        "mouseenter",
        this.onHoverMegamenu.bind(this, item)
      );
    });
  }

  onHoverMegamenu(item) {
    item.setAttribute("open", true);

    this.megamenuLinks.forEach((menu) => {
      const isHoveredItem = menu === item;
      const isChildOfHoveredItem =
        item.closest(".list-element") === menu.closest(".list-element");

      if (!isHoveredItem && !isChildOfHoveredItem) {
        menu.removeAttribute("open");
      }
    });
  }
  onClickDetails() {
    if (this.mainDetailsToggle.hasAttribute("data-megamenu-type")) {
      event.preventDefault();
    }
  }
  onHoverDetails() {
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout);
      this.leaveTimeout = null;
    }
    event.target.setAttribute("open", true);
  }
  onMouseLeaveDetails() {
    this.leaveTimeout = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute("open");
    }, 80);
  }
  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
